import { Mapper } from "../../../../base/utils/mapper";
import { GenderModel } from "../../../../domain/models/configuration/gender.model";
import { GenderEntity } from "../entities/gender.entity";


export class GenderImplementationRepositoryMapper extends Mapper<GenderEntity, GenderModel> {
    mapFrom(param: GenderEntity): GenderModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: GenderModel): GenderEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}